import eternal from "../images/icons/favicon-96x96.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faInstagram,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();

  return (
    <footer className="w-full bg-[#DC5D00] text-white text-sm py-6 px-8 font-main font-bold">
      <section
        className="max-w-7xl mx-auto justify-between flex flex-row gap-6
      border-b border-gray-200 sm:flex-col sm:justify-center"
      >
        {/* <div className="flex flex-row justify-start gap-12 mb-10">
          <p
          className="text-2xl font-bold text-transparent bg-clip-text"
          style={{
            backgroundImage: `url(${huellitas})`,
            backgroundSize: "cover",
            }}
            >
            BUSCA TU AMIGO
            </p>
            </div> */}

        <div className="flex flex-grow justify-center">
          <div className="flex flex-row justify-start gap-28 sm:gap-8 sm:flex-col sm:justify-center">
            <div className="flex flex-row justify-center mb-10 sm:justify-center sm:mb-0">
              <Link
              className="w-[96px] h-[96px]"
                to="/"
                onClick={(e) => {
                  if (location.pathname === "/") {
                    e.preventDefault();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }
                }}
              >
                <img
                  src="/catw.webp"
                  alt="Logo"
                  className="w-[96px] h-[96px]"
                />
              </Link>
            </div>
             <div className="flex w-fit flex-col text-start  sm:items-center">
              <h3 className="font-bold text-2xl font-main">Contacto</h3>
              <Link
                to="/quienes-somos"
                className="hover:text-primary transition font-main font-medium mt-2"
              >
                <FontAwesomeIcon
                  icon={faQuestionCircle}
                  className="mr-2 font-main"
                />{" "}
                Quiénes Somos
              </Link>
              <Link
                to="/preguntas-frecuentes"
                className="hover:text-primary transition font-main font-medium mt-2"
              >
                <FontAwesomeIcon
                  icon={faQuestionCircle}
                  className="mr-2 font-main"
                />{" "}
                Preguntas Frecuentes
              </Link>
            </div>

            <div className="flex flex-col items-start text-left sm:items-center">
              <h3 className="font-bold text-2xl font-main">Redes Sociales</h3>
              <div className="flex justify-start gap-4 mt-2">
                <a
                  href="https://www.facebook.com/profile.php?id=61574672947811"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-primary transition"
                >
                  <FontAwesomeIcon icon={faFacebookF} size="lg" />
                </a>
                <a
                  href="https://www.instagram.com/buscatuamigo/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-primary transition"
                >
                  <FontAwesomeIcon icon={faInstagram} size="lg" />
                </a>
          
              </div>
            </div>

            <section className="flex flex-col items-center text-left sm:items-center sm:mb-4">
              <h3 className="font-bold text-2xl font-main">Créditos</h3>
              <article>
                <a
                  href="https://www.eternalloopstudios.com/"
                  className="cursor-pointer"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={eternal}
                    alt="Eternal Loop Studios"
                    width="86px"
                    height="86px"
                  />
                </a>
              </article>
            </section>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto justify-evenly flex flex-row gap-6 sm:flex-col sm:justify-center text-center mt-6 text-gray-200 sm:items-center items-center">
        <p className="font-main font-medium">
          © {new Date().getFullYear()} EternalLoopStudios. Todos los derechos
          reservados.
        </p>
      </section>
    </footer>
  );
};

export default Footer;
